import { GetProps, Anchor as TAnchor, styled } from 'tamagui'

export const Anchor = styled(TAnchor, {
  name: 'Anchor',
  role: 'link',
  tag: 'a',
  textDecorationLine: 'none',
  hoverStyle: {
    textDecorationLine: 'underline',
  },
  focusVisibleStyle: { outlineColor: '$outlineColor' },
  variants: {
    variant: {
      red: {
        color: '$red6',
        focusVisibleStyle: { outlineColor: '$red6' },
      },
    },
  } as const,
})

export type AnchorProps = GetProps<typeof Anchor>
